import React from 'react';
import PropTypes from 'prop-types';
import { createCustomPropType, isNumeric } from '../../../js/app/react/validators';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

const WorkflowDoneV2View = ({ targetWorkflowID, clientID, onEditMyInformation, logout }) => {
  useDocumentTitle('Workflow Done');

  return (
    <section className="adv-workflow-container-ie11">
      <div className="adv-workflow-container-outer">
        <div className="adv-workflow-container-inner">
          <div className="adv-workflow-content generic-workflow">
            <div className="workflow-done-v2">
              <img
                className="workflow-done-v2-img"
                src={`${window.ADV.settings.endpoints.imgDir}pig-doctor.png`}
                alt="illustration"
              />
              <div className="workflow-done-v2-title">Thank you for your patience</div>
              <div className="workflow-done-v2-paragraph">
                Your information is being reviewed. Please check back for access to your dashboard.
              </div>
              <button className="mobile-consumer-overview-logout" type="button" onClick={logout}>
                <i className="mobile-consumer-overview-logout-i fa fa-sign-out-alt" />
                Logout
              </button>
              <div className="adv-workflow-navigation-next">
                <button
                  className="adv-workflow-navigation-next-save-button"
                  type="button"
                  onClick={onEditMyInformation(targetWorkflowID, clientID)}
                >
                  Edit my information
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

WorkflowDoneV2View.propTypes = {
  targetWorkflowID: PropTypes.oneOf(PropTypes.string, PropTypes.number).isRequired,
  clientID: createCustomPropType(isNumeric).isRequired,
  onEditMyInformation: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

export default WorkflowDoneV2View;
